import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    setAlert,
    setCreditCardForm,
    toggleCreditCardForm,
    updateBroadcastIndicator,
} from "../../../redux/actions";
import { connect } from "react-redux";
import PAlert from "../PAlert";
import VerifyModal from "../VerifyModal";
import {
    Snackbar,
    CircularProgress,
    IconButton,
    Dialog,
    DialogContent,
    useMediaQuery,
    useTheme,
} from "@mui/material";
import beamsClient from "../../utils/beam";
import CreditCardForm from "../CreditCardForm";
import { useHistory } from "react-router-dom";
import store from "../../../redux/reducers/reducer";
import { isMobileSafari } from "react-device-detect";

import "./style.scss";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

const stripePromise = loadStripe(process.env.MIX_STRIPE_KEY);

const Global = ({ showVerify, broadcastIndicator, creditCardForm }) => {
    const history = useHistory();
    const dispatch = useDispatch();
    const theme = useTheme();
    const activeUserID = localStorage.getItem("loggedin_user");
    const user = JSON.parse(localStorage.getItem("user"));

    const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

    const creditCardFormCurrency = useSelector(
        (state) => state.privaGlobal.creditCardForm.currency
    );
    const darkmode = useSelector((state) => state.privaGlobal.darkmode);
    const alert = useSelector((state) => state.privaGlobal.alert);

    const [beamsTokenProvider, setBeamsTokenProvider] = useState("");
    const [elementOptions, setElementOptions] = useState({});

    const handlePusherBeams = () => {
        if (activeUserID && beamsClient) {
            beamsClient
                .start()
                .then(() =>
                    beamsClient.setUserId(activeUserID, beamsTokenProvider)
                )
                .then(() =>
                    console.log("Successfully registered and subscribed!")
                )
                .catch(console.error);

            localStorage.setItem("beams", true);
        }
    };

    const validateBeams = () => {
        beamsClient
            .getUserId()
            .then((userId) => {
                // Check if the Beams user matches the user that is currently logged in
                if (userId != activeUserID) {
                    // Unregister for notifications
                    return beamsClient.stop();
                }
            })
            .catch(console.error);
    };

    const handleNewMessage = (d) => {
        const activeConv = store.getState().message.activeConv;

        if (d.detail.conversationID && d.detail.conversationID != activeConv) {
            setShowSnackbar(true);
            setSnackbarMessage(`New message from ${d.detail.senderName}`);
            setIsNewMessage(true);
        }
    };

    useEffect(() => {
        const token = localStorage.getItem("loggedin_access_token");
        if (token && beamsClient) {
            const pusherToken = new PusherPushNotifications.TokenProvider({
                url: "/api/pusher/beams-auth",
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            setBeamsTokenProvider(pusherToken);
        }

        const newMessage = (d) => {
            handleNewMessage(d);
        };

        const loadElements = async () => {
            await stripePromise;
            dispatch(
                setCreditCardForm({
                    formLoading: false,
                })
            );
        };

        loadElements();

        window.addEventListener("header/new-message", newMessage);
    }, []);

    useEffect(() => {
        if (beamsClient) {
            validateBeams();
            handlePusherBeams();
        }
    }, [beamsTokenProvider]);

    useEffect(() => {
        if (creditCardFormCurrency) {
            setElementOptions({
                mode: "setup",
                currency: creditCardFormCurrency,
            });
        }
    }, [creditCardFormCurrency]);

    useEffect(() => {
        setElementOptions({
            ...elementOptions,
            appearance: {
                theme: darkmode ? "night" : "stripe",
            },
        });
    }, [darkmode]);

    const [cardSuccess, setCardSuccess] = useState(false);

    useEffect(() => {
        if (cardSuccess) {
            handlePaymentClose();
        }
    }, [cardSuccess]);

    const handleShowAlert = () => {
        dispatch(
            setAlert({
                show: false,
                title: "",
                body: "",
            })
        );
    };

    const handleClose = (e, reason) => {
        if (reason === "clickaway") {
            return;
        }
        dispatch(updateBroadcastIndicator(false));
    };

    const handlePaymentClose = () => {
        dispatch(toggleCreditCardForm(false));
    };

    const [showSnackbar, setShowSnackbar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState("");
    const [isNewMessage, setIsNewMessage] = useState(false);
    const handleCloseSnackbar = (e, reason = "") => {
        e.stopPropagation();
        if (reason === "clickaway") {
            return;
        }
        setShowSnackbar(false);
        setSnackbarMessage("");
        setIsNewMessage(false);
    };

    const gotToMessages = (e) => {
        e.preventDefault();
        handleCloseSnackbar(e);
        history.push("/messages");
    };

    useEffect(() => {
        if (creditCardForm.show) {
            document.body.style.overflow = "auto";
        }
    }, [creditCardForm]);

    return (
        <React.Fragment>
            <PAlert
                onClose={alert.onClose}
                show={alert.show}
                setShow={handleShowAlert}
                title={alert.title}
                body={alert.body}
                bodyStyle={alert.bodyStyle}
                footerStyle={alert.footerStyle}
                size={alert.size ?? "sm"}
                modalStyle={{
                    zIndex: 21474836111,
                }}
            />

            {showVerify ? <VerifyModal show={showVerify} /> : null}

            {broadcastIndicator ? (
                <Snackbar
                    open={broadcastIndicator}
                    onClose={handleClose}
                    autoHideDuration={null}
                    className="broadcast-indicator"
                    action={
                        <IconButton
                            size="small"
                            aria-label="close"
                            color="inherit"
                            onClick={handleClose}
                            style={{ color: "white !important" }}
                        >
                            <i className="far fa-times"></i>
                        </IconButton>
                    }
                    anchorOrigin={{
                        vertical: "top",
                        horizontal: "right",
                    }}
                    message={
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <CircularProgress size={15} />{" "}
                            <span style={{ marginLeft: "4px" }}>
                                Processing broadcast message
                            </span>
                        </div>
                    }
                />
            ) : null}

            {creditCardForm.show && (
                <Dialog
                    open={creditCardForm.show}
                    onClose={handlePaymentClose}
                    className="creditCardModal"
                    onClick={(e) => e.stopPropagation()}
                    fullScreen={fullScreen}
                >
                    <DialogContent onClick={(e) => e.stopPropagation()}>
                        <Elements
                            stripe={stripePromise}
                            options={elementOptions}
                        >
                            <CreditCardForm
                                setSuccess={setCardSuccess}
                                setShow={handlePaymentClose}
                                intent={creditCardForm.intent}
                                puLogin={creditCardForm.username}
                                prefilled={creditCardForm.prefilled}
                                closeOnly={creditCardForm.closeOnly}
                                isModal
                            />
                        </Elements>
                    </DialogContent>
                </Dialog>
            )}

            {showSnackbar ? (
                <Snackbar
                    style={{ cursor: "pointer" }}
                    onClick={gotToMessages}
                    className={`${isNewMessage ? "snackbar-message" : ""}`}
                    open={showSnackbar}
                    onClose={handleCloseSnackbar}
                    autoHideDuration={null}
                    action={
                        <React.Fragment>
                            <IconButton
                                size="small"
                                aria-label="close"
                                color="inherit"
                                onClick={handleCloseSnackbar}
                            >
                                <i className="far fa-times"></i>
                            </IconButton>
                        </React.Fragment>
                    }
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "right",
                    }}
                    message={
                        <div style={{ display: "flex", alignItems: "center" }}>
                            {snackbarMessage}
                        </div>
                    }
                />
            ) : null}
        </React.Fragment>
    );
};

const mapStateToProps = (state) => {
    return {
        alert: state.privaGlobal.alert,
        showVerify: state.ccVerification.showVerify,
        broadcastIndicator: state.message.broadcastIndicator,
        creditCardForm: state.privaGlobal.creditCardForm,
    };
};

export default connect(mapStateToProps)(Global);
